import * as Highcharts from "highcharts";
import { getChartTheme } from './utils/chartTheme';

declare const coffee_dow : any[];
declare const coffee_monthly : any[];

function stats() {
    if(typeof coffee_dow === 'undefined') {
        return;
    }

    // Day of week chart
    Highcharts.chart('chart_dow', Highcharts.merge(getChartTheme(), {
        chart: { type: 'column', height: 320 },
        title: { text: 'Cups by Day of Week', style: { fontSize: '14px' } },
        xAxis: {
            categories: coffee_dow.map(d => d.name),
        },
        yAxis: {
            title: { text: '' },
            gridLineWidth: 0.1
        },
        legend: { enabled: false },
        series: [{
            type: 'column',
            name: 'Cups',
            data: coffee_dow.map(d => d.total),
            color: '#8B5E3C'
        }],
        credits: { enabled: false }
    }));

    // Monthly totals chart
    Highcharts.chart('chart_monthly', Highcharts.merge(getChartTheme(), {
        chart: { type: 'column', height: 320 },
        title: { text: 'Cups by Month', style: { fontSize: '14px' } },
        xAxis: {
            categories: coffee_monthly.map(d => d.month),
            labels: { rotation: -45 }
        },
        yAxis: {
            title: { text: '' },
            gridLineWidth: 0.1
        },
        legend: { enabled: false },
        series: [{
            type: 'column',
            name: 'Cups',
            data: coffee_monthly.map(d => d.total),
            color: '#8B5E3C'
        }],
        credits: { enabled: false }
    }));
}

export default class {
    static init = () => {
        stats();
    }
}
